import { render, staticRenderFns } from "./LicenseDetail.vue?vue&type=template&id=ed806712"
import script from "./LicenseDetail.vue?vue&type=script&lang=js"
export * from "./LicenseDetail.vue?vue&type=script&lang=js"
import style0 from "./LicenseDetail.vue?vue&type=style&index=0&id=ed806712&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports